module.exports = __webpack_public_path__ + "static/brand-logo-3d10d0e268e33cf49a1aad397dde40fe.png";